import { generateTaskForm } from "./TaskForm";

export default function AddonForm(props) {
  return generateTaskForm("addon_create", "create")(props);
}
